module.exports = __webpack_public_path__ + "static/media/cocktail-bar.56b4a908.png";